import { render, staticRenderFns } from "./ServiceAppDevelopment.vue?vue&type=template&id=937a7326&scoped=true&"
import script from "./ServiceAppDevelopment.vue?vue&type=script&lang=js&"
export * from "./ServiceAppDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAppDevelopment.vue?vue&type=style&index=0&id=937a7326&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937a7326",
  null
  
)

export default component.exports